import type { SyncSession } from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';
import { ReactiveState } from '../../../utils/ReactiveState';

export const allSyncSessions = new ReactiveState<
  SyncSession[],
  'allSyncSessions'
>([], 'allSyncSessions');

export const syncSessionsMap = new ReactiveMap<
  string,
  SyncSession,
  'syncSessionsMap'
>('syncSessionsMap');

allSyncSessions.set([]);
syncSessionsMap.clear();
